import _ from "lodash";
import React from "react";
import { useLazyGetReportsSummaryQuery } from "../../../services/clientreports";

export const ReportsSummaryContext = React.createContext();

export const useReportsSummaryData = () => React.useContext(ReportsSummaryContext);

export const ReportsSummaryProvider = ({ children, filter = null, isReady = false }) => {
    const [load, { data, error, isLoading, isFetching }] = useLazyGetReportsSummaryQuery();
    
    const reload = () => {
        if (!isReady || !filter || _.isEmpty(filter)) {
            return;
        }
        load({ ...filter }).unwrap();
    };

    React.useEffect(reload, [ filter, isReady ]);

    return (
        <ReportsSummaryContext.Provider value={{ data, error, isLoading, isFetching }}>
            {children}
        </ReportsSummaryContext.Provider>
    )
}
